<template>
    <div>
        <div class="popup popup-stateroom" :class="{ 'modal-in': isShow, 'modal-out': !isShow}" id="contactEdit">
            <div class="js-returnDetailBtn">
                <a class="returnButton" @click="onGoBack()">
                    <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/arrowRightBlack.png">
                </a>
                <p class="popup-title">{{isNewContact ? '新建联系人': '编辑联系人'}}</p>
            </div>
            <div class="new-passenger-content scroll-container" style="">
                <div class="new-passenger-detail js-smartScroll">
                    <form>
                        <div class="passenger-detail-desc">
                            <div class="passenger-content" @click="isShowCountry=true">
                                <div class="passenger-family">国家或地区</div>
                                <div class="passenger-txt nationality-txt">
                                    <div class="css_nationality js_nationality">{{getCountryName(contact.country)}}</div>
                                </div>
                                <div class="passenger-arrow-right"></div>
                            </div>
                            <div class="passenger-content">
                                <div class="passenger-family passenger-title-short">中文姓</div>
                                <div class="passenger-txt">
                                    <input type="text" :placeholder="isFromMainland ? '必填': '选填'" v-model="contact.chineseLastName" 
                                    name="chinese-family" id="chinese-family" class="chinese-family"
                                    @change="onNameChange($event, 'lastName')"
                                    >
                                </div>
                                <div class="passenger-family passenger-title-short">中文名</div>
                                <div class="passenger-txt">
                                    <input type="text" :placeholder="isFromMainland ? '必填': '选填'" v-model="contact.chineseFirstName" 
                                    name="chinese-name" id="chinese-name" class="chinese-name"
                                     @change="onNameChange($event, 'firstName')"
                                    >
                                </div>
                                
                            </div>
                            <div class="passenger-content">
                                <div class="passenger-family passenger-title-short">姓拼音</div>
                                <div class="passenger-txt">
                                    <input type="text" :placeholder="isFromMainland ? '必填': '必填 last name'" v-model="contact.pinyinLastName" name="family-pinyin" id="family-pinyin" class="family-pinyin">
                                </div>
                                <div class="passenger-family passenger-title-short">名拼音</div>
                                <div class="passenger-txt">
                                    <input type="text" :placeholder="isFromMainland ? '必填': '必填 first name'" v-model="contact.pinyinFirstName" name="name-pinyin" id="name-pinyin" class="name-pinyin">
                                </div>
                            </div>
                            <div class="passenger-content">
                                <div class="passenger-family">性别（必选）</div>
                                <div class="passenger-txt passenger-male">
                                    <div class="male-txt" @click="onGenderChange('M')" :class="{ active: (contact.gender == 'M' || contact.gender == '男')}">
                                        <i></i>
                                        <span>男</span>
                                    </div>
                                    <div class="female-txt" @click="onGenderChange('F')"  :class="{ active: (contact.gender == 'F' || contact.gender == '女')}">
                                        <i></i>
                                        <span>女</span>
                                    </div>
                                </div>
                            </div>
                            <div class="passenger-content passenger-birthDate">
                                <div class="passenger-family">出生日期（必填）</div>
                                <div class="passenger-txt">
                                    <input ref='dateOfBirthInput' placeholder="必填" @change="contact.dateOfBirth=$event.target.value" 
                                    :value="contact.dateOfBirth" name="birth-date" id="birth-date" class="birth-date">
                                </div>
                                <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/calendarIcon.png">
                            </div>
                            <div class="passenger-optional">
                                <div class="optionalContent" v-show="isShowMore">
                                    <div class="passenger-content">
                                        <div class="passenger-family phone-css">
                                            手机号
                                        </div>
                                        <span class="passenger-callingCode callingCode-text">{{getCallingCodeName(contact.callingCode)}}</span>
                                        <select class="callingCode-css newCallingCode-js" @change="changeContactCalllingCode($event)">
                                                <option v-for="(country, i) in smsCallingCodes" 
                                                :key="('callingCode_' + i)"
                                                :selected="getCallingCode(contact.callingCode) == country.callingCode"
                                                :value="country.callingCode"
                                                >
                                                    {{getCallingCodeName(country.callingCode)}}
                                                </option>
                                        </select>
                                        <div class="passenger-txt">
                                            <input type="text" placeholder="请输入手机号" v-model="contact.telephone" name="telphone-number" id="telphone-number" class="telphone-number">
                                        </div>
                                    </div>
                                    <div class="passenger-content">
                                        <div class="passenger-family">护照号</div>
                                        <div class="passenger-txt">
                                            <input type="text" placeholder="" v-model="contact.passportNum" name="passport-no" id="passport-no" class="passport-no">
                                            <span class="passportClearBtn" @click="contact.passportNum=''">清空</span>
                                        </div>
                                    </div>
                                    <div class="passenger-content passenger-pssport">
                                        <div class="passenger-family">护照有效期至</div>
                                        <div class="passenger-txt">
                                            <input ref='passportDate' @change="contact.passportExpirationDate=$event.target.value"
                                            :value="contact.passportExpirationDate" name="passport-validity" id="passport-validity" class="passport-validity">
                                        </div>
                                        <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/calendarIcon.png">
                                    </div>
                                    <div class="passenger-content">
                                        <div class="passenger-family">电子邮箱</div>
                                        <div class="passenger-txt">
                                            <input type="text" placeholder="" v-model="contact.email" name="mail-box" id="mail-box" class="mail-box">
                                        </div>
                                    </div>
                                    
                                </div>
                                <div class="optionalTxt" @click="isShowMore=!isShowMore">{{isShowMore ? '收起(选填)':'展开(选填)'}}</div>
                            </div>

                        </div>
                    </form>
                    <div class="passenger-defaultGuest" 
                    :class="{ active: contact.isDefaultContact}"
                    @click="contact.isDefaultContact=!contact.isDefaultContact"
                    >
                        <div>
                            <div class="passenger-defaultGuest-l">
                                保存为默认联系人
                            </div>
                            <div class="passenger-defaultGuest-r">
                                <span>
                                    <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/orderSelectIcon.png">
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="passenger-save" @click="onSubmitClick()">保存</div>
                </div>
            </div>
            
        </div>

        <CountrySelector 
            :isShow="isShowCountry"
            :onCountrySelected="onCountrySelected"
            :onCountryClose="onCountryClose"
        />
    </div>
</template>

<script>
import api from '@/api'
import Picker from 'pickerjs'
import 'pickerjs/dist/picker.min.css'
const CountrySelector = () => import ('@/components/Booking/CountrySelector')
import { isChinese, isLetter, checkTel, checkMail, checkPassport } from '@/utilities/tools'
export default {
    name: 'GuestInfoContactEdit',
    components: {
        CountrySelector
    },
    props: {
        isShow: {
            type: Boolean
        },
        onGoBack: {
            type: Function
        },
        onSubmitSuccess: {
            type: Function
        },
        targetContact: {
            type: Object,
            default () {
                return {}
            }
        },
        isNewContact: {
            type: Boolean
        }
    },
    data () {
        return {
            contact: {
                callingCode: '',
                chineseFirstName: '',
                chineseLastName: '',
                country: '',
                dateOfBirth: '',
                email: '',
                gender: '',
                isDefaultContact: false,
                passportExpirationDate: '',
                passportNum: '',
                pinyinFirstName: '',
                pinyinLastName: '',
                telephone: ''
            },
            isShowMore: false,
            isShowCountry: false
        }
    },
    mounted () {
        new Picker(this.$refs.dateOfBirthInput, {
            format: 'YYYY-MM-DD',
            date: new Date(1980, 0, 1),
            text: {
                title: '请选择出生日期(年/月/日)',
                cancel: '取消',
                confirm: '确认',
            },
        })
        new Picker(this.$refs.passportDate, {
            format: 'YYYY-MM-DD',
            date: new Date(),
            text: {
                title: '请选择护照有效期(年/月/日)',
                cancel: '取消',
                confirm: '确认',
            },
        })
    },
    methods: {
        getCallingCode(callingCode) {
            let code = callingCode + ''
            if (!code || code.length == 0) {
                code = '+86'
            }
            if (code.indexOf('+') < 0) {
                code = "+" + code
            }
            return code
        },
        getCallingCodeName (callingCode) {
            const code = this.getCallingCode(callingCode)
            const country = this.smsCallingCodes.filter(r=>r.callingCode == code)
            if (country.length == 0) {
                return '中国(+86)'
            }
            return `${country[0].countryName}(${code})`
        },
        changeContactCalllingCode (e) {
            let code = e.target.value + ''
            if (code.indexOf('+') >= 0) {
                code = code.replace('+', '')
            }
            this.contact.callingCode = code
        },
        getCountryName (countryCode) {
            const country = this.countries.filter(r=>r.countryCode == countryCode || r.countryName == countryCode)
            if (country.length == 0) {
                return ""
            }
            return country[0].countryName
        },
        onCountrySelected (countryCode) {
            this.contact.country =countryCode
            this.isShowCountry = false
        },
        onCountryClose () {
            this.isShowCountry = false
        },
        onGenderChange (gender) {
            this.contact.gender = gender
        },
        onNameChange (e, key) {
            const value = e.target.value
            this.getPinyin(key, value)
        },
        async getPinyin (key, value) {
            if (!value || value.length == 0) return
            const { data } = await api.page.getPinyin(value)
            if (data && data.length > 0) {
                if (key == 'firstName') {
                    this.contact.pinyinFirstName = data
                } else if (key == 'lastName') {
                    this.contact.pinyinLastName = data
                }
            }
        },
        async onSubmitClick () {
            if (!this.checkContactInfo()) {
                return
            }
            this.contact = Object.assign({
              UpdateFields:
                  ['Country','CallingCode','ChineseLastName','ChineseFirstName','PinYinLastName','PinYinFirstName','Gender','DateOfBirth','PassPortNum','Telephone','PassPortExpirationDate','Email']
            },this.contact);
            console.log(this.contact)
            if (this.isNewContact) {
                // 创建
                this.$loading.show()
                const { success, errMsg } = await api.user.createContact(this.contact)
                this.$loading.hide()
                if (!success) {
                    this.$alert.show(errMsg)
                    return
                }
            } else {
              this.$loading.show()
              const { success, errMsg } = await api.user.updateContact(this.contact)
              this.$loading.hide()
              if (!success) {
                  this.$alert.show(errMsg)
                  return
              }
            }
            this.onSubmitSuccess()
        },
        checkContactInfo () {
            if (!this.contact.pinyinLastName || this.contact.pinyinLastName.trim() == '') {
                this.$alert.show('请输入姓拼音')
                return false
            } else if (!this.contact.pinyinFirstName || this.contact.pinyinFirstName.trim() == '') {
                this.$alert.show('请输入名拼音')
                return false
            } else if (!isLetter(this.contact.pinyinLastName)) {
                this.$alert.show('请输入正确的名拼音')
                return false
            } else if (!isLetter(this.contact.pinyinFirstName)) {
                this.$alert.show('请输入正确的名拼音')
                return false
            }else if (!this.contact.dateOfBirth || this.contact.dateOfBirth.trim() == '') {
                this.$alert.show('请选择出生日期')
                return false
            } else if (!this.contact.gender || this.contact.gender.trim() == '') {
                this.$alert.show('请选择性别')
                return false
            } else if (!this.contact.country || this.contact.country.trim() == '') {
                this.$alert.show('请选择国家或地区')
                return false
            }

            if (this.contact.country == 'CN') {
                if (!this.contact.chineseLastName || this.contact.chineseLastName.trim() == '') {
                    this.$alert.show('请输入中文姓')
                    return false
                } else if (!this.contact.chineseFirstName || this.contact.chineseFirstName.trim() == '') {
                    this.$alert.show('请输入中文名')
                    return false
                } else if (!isChinese(this.contact.chineseLastName)) {
                    this.$alert.show('请输入正确的中文姓')
                    return false
                } else if (!isChinese(this.contact.chineseFirstName)) {
                    this.$alert.show('请输入正确的中文名')
                    return false
                }

                if (this.contact.passportNum&&this.contact.passportNum.length > 0 && !checkPassport(this.contact.passportNum)) {
                    this.$alert.show('请输入正确的护照号')
                    return false
                }
            }

            if (this.contact.telephone&&this.contact.telephone.length > 0 && !checkTel(this.contact.telephone) 
            && this.contact.callingCode && this.contact.callingCode.indexOf('86')>=0) {
                this.$alert.show('请输入正确的手机号')
                return false
            }

            if (this.contact.email&&this.contact.email.length > 0 && !checkMail(this.contact.email)) {
                this.$alert.show('请输入正确的邮箱')
                return false
            }

            return true
        },
        async getCountry () {
          const {success, data, errMsg} = await api.user.userEditInfo()
          let countryList = success ? data.nationalityApiViews : null;
          console.log(errMsg)
          this.$store.commit('SET_COUNTRIES', countryList);
        }
    },
    computed: {
        smsCallingCodes () {
            return this.$store.getters.smsCallingCodes
        },
        countries() {
            if(this.$store.state.page.countries.length === 0) {
              this.getCountry()
            }
            return this.$store.state.page.countries
        },
        isFromMainland() {
            return this.contact.country == 'CN' || this.contact.country == '中国'
        }
    },
    watch: {
        targetContact (newOne) {
            // 每次新打开，折叠选填部分
            this.isShowMore = false
            this.isShowCountry = false
            this.contact = {
                id: newOne.id,
                callingCode: newOne.callingCode || '86',
                chineseFirstName: newOne.chineseFirstName || '',
                chineseLastName: newOne.chineseLastName || '',
                country: newOne.country || 'CN',
                dateOfBirth: newOne.dateOfBirth || '',
                email: newOne.email || '',
                gender: newOne.gender || '',
                isDefaultContact: newOne.isDefaultContact || false,
                passportExpirationDate: newOne.passportExpirationDate || '',
                passportNum: newOne.passportNum || '',
                pinyinFirstName: newOne.pinyinFirstName || '',
                pinyinLastName: newOne.pinyinLastName || '',
                telephone: newOne.telephone || ''
            }

        }
    }
}
</script>

<style lang="less" scoped>
input::-webkit-input-placeholder {
    font-size: 12px;
    color: #999;
}
#contactEdit.popup {
    position: fixed;
    background-color: #F6F7F8;
    transform: translate3d(100%, 0, 0);
    display: block;
}
#contactEdit.modal-in {
    position: fixed;
    background-color: #F6F7F8;
    transform: translate3d(0, 0, 0);
}
#contactEdit.modal-out {
    transform: translate3d(100%, 0, 0);
}

#contactEdit .js-returnDetailBtn {
    position: fixed;
    width: 100%;
    text-align: center;
    height: 50px;
    line-height: 50px;
    background-color: #fff;
    z-index: 30;
    .returnButton {
        width: 30px;
        position: absolute;
        top: 4px;
        left: 20px;
        text-align: left;
        img {
            width: 33%;
        }
    }
    .popup-title {
        font-family: PingFang-SC-Medium;
        font-size: 14px;
        color: #333333;
        letter-spacing: 1px;
        margin: 0;
    }
}

.new-passenger-content {
    .new-passenger-detail {
        position: relative;
        /* top: 55px; */
        z-index: 22;
        height: 100%;
        padding-top: 70px;
        padding-bottom: 50px;
        overflow-y: scroll;
        background: #F6F7F8;
        .passenger-detail-desc {
            background: #fff;
            padding: 9px 20px 0;
        }
        .passenger-content {
            position: relative;
            display: -webkit-box;
            display: -webkit-flex;
            display: -moz-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-align: center;
            -webkit-align-items: center;
            -moz-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            width: 100%;
            height: 46px;
            border-bottom: 1px solid #e8e8e8;
            .passenger-family, .passenger-txt {
                font-size: 14px;
                line-height: 20px;
                color: #333;
            }
            .passenger-txt input, .passenger-txt select {
                position: relative;
                z-index: 1;
                display: block;
                width: 100%;
                height: 20px;
                color: #333;
                -webkit-appearance: none;
                outline: none;
                border: none;
                border-radius: 0;
                padding: 0;
                background-color: transparent;
            }
            .passenger-family {
                -webkit-box-flex: 0;
                -webkit-flex: none;
                -moz-box-flex: 0;
                -ms-flex: none;
                flex: none;
                width: 115px;
            }
            .passenger-txt {
                -webkit-box-flex: 1;
                -webkit-flex: 1;
                -moz-box-flex: 1;
                -ms-flex: 1;
                flex: 1;
                position: relative;
                padding-right: 10px;
            }
            .passenger-arrow-right {
                position: absolute;
                right: 0;
                top: 50%;
                -webkit-transform: translateY(-50%) rotate(-45deg);
                -moz-transform: translateY(-50%) rotate(-45deg);
                -ms-transform: translateY(-50%) rotate(-45deg);
                -o-transform: translateY(-50%) rotate(-45deg);
                transform: translateY(-50%) rotate(-45deg);
                width: 10px;
                height: 10px;
                border-right: 1px solid #4A90E2;
                border-bottom: 1px solid #4A90E2;
            }
            .passenger-title-short {
                width: 55px;
            }
            .passenger-male {
                display: -webkit-box;
                display: -webkit-flex;
                display: -moz-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-align: center;
                -webkit-align-items: center;
                -moz-box-align: center;
                -ms-flex-align: center;
                align-items: center;
            }
            .male-txt, .female-txt {
                display: -webkit-box;
                display: -webkit-flex;
                display: -moz-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-align: center;
                -webkit-align-items: center;
                -moz-box-align: center;
                -ms-flex-align: center;
                align-items: center;
                span {
                    margin-left: 11px;
                }
                i {
                    display: -webkit-box;
                    display: -webkit-flex;
                    display: -moz-box;
                    display: -ms-flexbox;
                    display: flex;
                    -webkit-box-pack: center;
                    -webkit-justify-content: center;
                    -moz-box-pack: center;
                    -ms-flex-pack: center;
                    justify-content: center;
                    -webkit-box-align: center;
                    -webkit-align-items: center;
                    -moz-box-align: center;
                    -ms-flex-align: center;
                    align-items: center;
                    width: 13px;
                    height: 13px;
                    border-radius: 50px;
                    border: 1px solid #4A90E2;
                }
            }
            .active i::before {
                content: '';
                display: block;
                width: 5px;
                height: 5px;
                border-radius: 50px;
                background-color: #4A90E2;
            }
            .male-txt {
                margin-right: 44px;
            }
            .phone-css {
                width: 50px;
            }
            .callingCode-text {
                background: url(https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-down-1.jpg) no-repeat right transparent;
                border: 0;
                -moz-appearance: none;
                -webkit-appearance: none;
                padding-right: 20px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                display: inline-block;
                margin-right: 15px;
                margin-left: 5px;
                font-size: 14px;
                line-height: 20px;
                color: #333;
                max-width: 120px;
            }
            .callingCode-css {
                opacity: 0;
                position: absolute;
                left: 50px;
                z-index: 2;
                width: 93px;
            }

            .passportClearBtn {
                position: absolute;
                right: 0;
                top: 50%;
                z-index: 3;
                -webkit-transform: translateY(-50%);
                -moz-transform: translateY(-50%);
                -ms-transform: translateY(-50%);
                -o-transform: translateY(-50%);
                transform: translateY(-50%);
                padding: 4px 3px;
                font-size: 12px;
                line-height: 1;
                color: #4A90E2;
                background: #fff;
                border-radius: 3px;
                border: 1px solid #4A90E2;
            }

        }

        .passenger-optional {
            .optionalTxt {
                display: -webkit-box;
                display: -webkit-flex;
                display: -moz-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-align: center;
                -webkit-align-items: center;
                -moz-box-align: center;
                -ms-flex-align: center;
                align-items: center;
                -webkit-box-pack: center;
                -webkit-justify-content: center;
                -moz-box-pack: center;
                -ms-flex-pack: center;
                justify-content: center;
                padding: 12px 0;
                font-size: 12px;
                line-height: 20px;
                color: #999;
            }
            .optionalTxt::after {
                content: '';
                display: block;
                width: 6px;
                height: 6px;
                margin-top: -4px;
                margin-left: 10px;
                -webkit-transform: rotate(45deg);
                -moz-transform: rotate(45deg);
                -ms-transform: rotate(45deg);
                -o-transform: rotate(45deg);
                transform: rotate(45deg);
                border-right: 1px solid #999;
                border-bottom: 1px solid #999;
            }
        }

        .passenger-birthDate img, .passenger-pssport img {
            position: absolute;
            right: 0;
            top: 50%;
            -webkit-transform: translateY(-50%);
            -moz-transform: translateY(-50%);
            -ms-transform: translateY(-50%);
            -o-transform: translateY(-50%);
            transform: translateY(-50%);
            width: 20px;
            pointer-events: none;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
        }

        .passenger-defaultGuest {
            margin-top: 10px;
            background-color: #f1f1f1;
            overflow: hidden;
            > div {
                background-color: #fff;
                overflow: hidden;
                padding: 20px 10px;
            }
            .passenger-defaultGuest-l {
                font-family: PingFang-SC-Medium;
                font-size: 14px;
                color: #333333;
                float: left;
            }
            .passenger-defaultGuest-r {
                float: right;
                span {
                    display: inline-block;
                    width: 32px;
                    height: 17px;
                    text-align: left;
                    background: #FFFFFF;
                    border: 1px solid #CCCCCC;
                    border-radius: 10px;
                    border-radius: 10px;
                    vertical-align: middle;
                    margin-left: 6px;
                }
                img {
                    width: 20px;
                    margin-top: -2px;
                    margin-left: -4px;
                }
            }
        }

        .passenger-defaultGuest.active .passenger-defaultGuest-r span {
            background-color: rgba(73, 143, 225, 1.0);
            text-align: right;
        }

        .passenger-defaultGuest.active .passenger-defaultGuest-r span img {
            margin-right: -2px;
        }

        .passenger-save {
            background-image: -webkit-linear-gradient(right, #FAD961 0%, #FEBC10 100%);
            background-image: -moz-linear-gradient(right, #FAD961 0%, #FEBC10 100%);
            background-image: -o-linear-gradient(right, #FAD961 0%, #FEBC10 100%);
            background-image: linear-gradient(270deg, #FAD961 0%, #FEBC10 100%);
            color: #454545;
            text-align: center;
            height: 50px;
            line-height: 50px;
            width: 100%;
            margin: 35px auto;
            font-size: 16px;
            overflow: hidden;
        }

    }

    
}

</style>